"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusShift = void 0;
const gamepadEvents_1 = require("../../core/gamepadEvents");
const createUseSubscriptionHandler_1 = require("../inner-utility/createUseSubscriptionHandler");
/**
 * Fires given handlers when the focus shifts from one element to another.
 * This is not called for initial focus.
 * @param handler - the handler when focus shifts between elements (previousFocus to nextFocus).
 * Return true to prevent this from propagating further up the tree.
 */
exports.useFocusShift = (0, createUseSubscriptionHandler_1.createUseSubscriptionHandler)(gamepadEvents_1.NavigationEvent.Shift);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRm9jdXNTaGlmdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9uYXZpZ2F0aW9uL3VzZUZvY3VzU2hpZnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELDREQUEyRDtBQUUzRCxnR0FBNkY7QUFFN0Y7Ozs7O0dBS0c7QUFDVSxRQUFBLGFBQWEsR0FBRyxJQUFBLDJEQUE0QixFQUV2RCwrQkFBZSxDQUFDLEtBQUssQ0FBQyxDQUFDIn0=